import { E2E_FILE_TYPE_ENUM } from '@/constant/common';
import { saveAs } from 'file-saver';
import _ from 'lodash';

export default {
  install(Vue, options) {
    Vue.prototype.$downloadFile = function(data, fileName, contentType) {
      console.log('filename', fileName);
      let filename = _.cloneDeep(fileName);
      let fileType, suffix;
      console.log(contentType);
      if (typeof fileName === 'string') {
        const nameParts = fileName.split('.');
        suffix = nameParts[nameParts.length - 1].toLowerCase();
        for (const typeKey in E2E_FILE_TYPE_ENUM) {
          E2E_FILE_TYPE_ENUM[typeKey].map((item, index) => {
            if (item === suffix) {
              fileType = typeKey;
            }
          });
        }
      } else if (filename.headers['content-disposition']) {
        const contentDisposition = decodeURIComponent(filename.headers['content-disposition']);
        const str = contentDisposition.split(';')[1];
        filename = str.split('=')[1];
        fileType = filename.split('.')[1];
      } else {
        filename = 'file';
      }

      // if (!fileType) return this.$message.error('无法识别文件类型');
      // let type = '';
      // if (navigator.userAgent.indexOf('Firefox') == -1) {
      //   switch (fileType) {
      //     case 'pdf':
      //       type = 'application/pdf';
      //       break;
      //     case 'excel':
      //       type = 'application/vnd.ms-excel';
      //       break;
      //     case 'word':
      //       type = 'application/msword';
      //       break;
      //     case 'image':
      //       type = 'image/jpeg';
      //       break;
      //     case 'ppt':
      //       type = 'application/vnd.ms-powerpoint';
      //       break;
      //     case 'msg':
      //       type = 'application/octet-stream';
      //       break;
      //     default:
      //       type = '';
      //       return;
      //   }
      // }
      if (navigator.userAgent.indexOf('Edge') > -1 || 'msSaveOrOpenBlob' in navigator) {
        const blob = new Blob([data], filename);
        console.log(blob);
        console.log(window.navigator.msSaveOrOpenBlob(blob, filename));
        saveAs(blob, filename);
        return;
      }
      // if (navigator.userAgent.indexOf('Safari')) {
      //   const oPop = window.open(window.URL.createObjectURL(new Blob([data], filename)), '', 'width=1, height=1, top=5000, left=5000');
      //   oPop.document.execCommand('SaveAs');
      //   oPop.close();
      // }
      const file = new File([data], filename, { type: contentType });
      saveAs(file);
      // const url = window.URL.createObjectURL(new Blob([data], { type }));
      // const link = document.createElement('a');
      // link.style.display = 'none';
      // link.href = url;
      // link.setAttribute('download', filename);
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link); // 下载完成移除元素
      // window.URL.revokeObjectURL(url); // 释放掉blob对象
    };

    // 检查返回的数据是否是文件流数据
    Vue.prototype.$checkFileStream = function(data) {
      return new Promise((resolve, reject) => {
        const ab = new Buffer(data.data);
        try {
          const resJson = JSON.parse(ab); // 成功返回文件流这行会报错
          // 未获取到文件流，请求以json 格式成功返回了
          reject(resJson);
        } catch (e) {
          // 获取到文件流
          resolve(data);
        }
      });
    };
  }
};



// WEBPACK FOOTER //
// ./src/libs/download/index.js